import { CurrencyPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CsAgentAuthService } from "@spartacus/asm/root";
import { CmsService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import html2pdf from 'html2pdf.js';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { MakeAPaymentService } from 'src/app/make-a-payment/make-a-payment.service';
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CommonUtils } from 'src/app/shared/utils/common.utils';
import { NumberTen, NumberThree, NumberTwo } from 'src/app/shared/utils/constants/global.constants';
import { InvoiceUtils } from 'src/app/shared/utils/invoice.utils';
import { AccountOverviewService } from '../../account-overview.service';

const symbolNarrow = 'symbol-narrow';
const tabs = ['INVOICES', 'PAYMENTS', 'CREDITS', 'STATEMENTS'];
@Component({
    selector: 'app-financials-list',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './financials-list.component.html',
    styleUrls: ['./financials-list.component.scss'],
    standalone: false
})
export class FinancialsListComponent implements OnInit, OnDestroy {
  isLoadingDone: boolean = false;
  selectedTab: string = tabs[0];
  removeAside = true;
  currentDate = new Date();
  paymentList: any = [];
  showdropdown = false;
  creditList: any = [];
  payment: any;
  myDate: string;
  userAccSub: Subscription;
  creditItems: any = [];
  invoiceItems: any = [];
  creditDropDownSource: any[];
  listofSelectedInvoices: any = [];
  indexOfSelectedInvoice: any;
  accountNumber: string = null;
  isPDF = false;
  showXlsPdf = false;
  excelInvoiceHeaderIds: string[] = [
    'blineDate',
    'dueDate',
    'customer',
    'refDocNo',
    'amount',
    'prompt_pay',
    'amountDue'
  ];
  excelCreditsHeaderIds: string[] = ['creditDate', 'creditNo', 'creditAmt'];
  creditInvoiceSub: Subscription;
  paymentListSub: Subscription;
  paymentHistoryList: any;
  userDataSub: Subscription;
  userDetails: any;
  LocationListSub: any;
  isLocationSelected: boolean;
  selectedLocations: any;
  isAsmUser: boolean = false;
  firewallExempt: boolean = false;
  isComServeAgent: boolean = false;
  csAgentAuthSubscription: Subscription;
  creditInvFullResult: any;
  paymentFullResult: any;
  displayBilling: boolean = false;
  billingDisplaySubscrition: any;
  isLoading: boolean = true;
  constructor(
    private readonly datePipe: DatePipe,
    private readonly currencyPipe: CurrencyPipe,
    private readonly makeAPayment: MakeAPaymentService,
    private readonly cdr: ChangeDetectorRef,
    private readonly acService: AccountOverviewService,
    private readonly user: UserAccountFacade,
    private readonly locStripService: LoactionStripService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly cmsData: CmsService,
    private readonly customProfService: CustomProfileAndPreferencesService,
    private readonly sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.invoiceItems = [];
    this.creditItems = [];
    sessionStorage.removeItem('creditData');
    sessionStorage.removeItem('invoicesData');
    this.myDate = this.datePipe.transform(this.currentDate, 'MM/dd/yyyy');
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    this.LocationListSub = this.locStripService.emitSelectedLocs.subscribe(locsData => {
      this.isLocationSelected = !!locsData?.length;
      this.selectedLocations = locsData;
    });
    this.userDataSub = this.user.get().subscribe((res) => {
      if (res !== undefined) {
        this.userDetails = res;
        this.getPaymentData();
      }
    });
    this.customProfService._userAccountData.pipe(filter(res => !!res), map(({ defaultB2BUnit }) => ({ uid: defaultB2BUnit.uid })))
      .subscribe((res: any) => {
        if (this.accountNumber === null) {
          this.accountNumber = res?.uid;
          this.getInvoicesCreditData();
          this.cdr.detectChanges();
        }
        this.customProfService._userAccountDetails.pipe(filter(res1 => !!res1)).subscribe(res1 => {
          this.displayBilling = res1.billingDisplay;
          this.cdr.detectChanges();


        });
      });
    this.creditInvoiceSub = this.makeAPayment.makePaymentData$.subscribe(
      (res) => {
        if (res !== false) {
          this.creditInvFullResult = res;
          if (res?.isComServeAgent) {
            this.isComServeAgent = res.isComServeAgent;
          }
          this.paymentList = InvoiceUtils.getInvoiceTableData(res.openInvoices);
          this.paymentList?.forEach(element => {
            element.paymentAmnt = (Number(element?.lcAmount) - Number(element?.discAmount)).toFixed(2);
          })
          this.creditDropDownSource = InvoiceUtils.getCreditDropDownSource(
            this.paymentList
          );
          this.creditList = InvoiceUtils.getCreditTableData(
            res.openInvoices,
            this.creditDropDownSource
          );

          this.paymentList = CommonUtils.sortArr(
            'blineDate',
            this.paymentList,
            'Date',
            -1
          );
          this.paymentList =
            !!this.paymentList && this.paymentList?.length >= NumberTen
              ? this.paymentList.slice(0, NumberTen)
              : this.paymentList.slice();
          this.creditList = CommonUtils.sortArr(
            'blineDate',
            this.creditList,
            'Date',
            -1
          );
          this.paymentList.forEach(element => {
            if (element?.customer && element?.customer !== '' && element?.customer !== null) {
              element.customer = '00' + element?.customer;
            }
          });
          this.creditList =
            !!this.creditList && this.creditList?.length >= NumberTen
              ? this.creditList.slice(0, NumberTen)
              : this.creditList.slice();
          this.paymentList.forEach((element) => {
            element.paymentAmount = this.currencyPipe.transform(
              element?.amount,
              'USD',
              symbolNarrow,
              '1.2-2'
            );
          });
          this.isLoadingDone = true;
          this.isLoading = false;
          this.tabNavigation(tabs[0]);
          this.cdr.detectChanges();
        } else {
          this.isLoadingDone = true;
        }
      }
    );
  }

  getInvoicesCreditData() {
    this.makeAPayment.getInvoices({
      accountId: this.accountNumber,
      fields: 'DEFAULT',
      cached: 'true',
    });
  }
  getPaymentData() {
    let accountIds;
    if (this.isLocationSelected) {
      if (this.selectedLocations.length > 1) {
        accountIds = '';
      }
      this.selectedLocations.forEach((loc) => {
        if (this.selectedLocations.length > 1) {
          accountIds = (accountIds === '') ? loc.accountNumber : accountIds + ',' + loc.accountNumber;
        }
        else {
          accountIds = loc.accountNumber;
        }
      })
    }
    this.acService.getPaymentList(this.userDetails?.uid, accountIds);
    this.paymentListSub = this.acService.paymentList$.subscribe((res) => {
      if (res !== null) {
        this.paymentFullResult = res;
        this.paymentHistoryList = res?.paymentHistoryList;
      }
    })
  }

  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }

  invoicePdf(invoiceNo): void {
    this.makeAPayment.downloadPdf(invoiceNo);
  }

  creditPdf(creditNo): void {
    this.makeAPayment.downloadPdf(creditNo);
  }

  tabNavigation(id): void {
    this.selectedTab = id;
    if (this.selectedTab === tabs[0]) {
      this.showXlsPdf =
        !!this.paymentList && this.paymentList?.length > 0 ? true : false;
      this.cdr.detectChanges();
    } else if (this.selectedTab === tabs[2]) {
      this.showXlsPdf =
        !!this.creditList && this.creditList?.length > 0 ? true : false;
      this.cdr.detectChanges();
    } else {
      this.showXlsPdf = false;
      this.cdr.detectChanges();
    }
  }

  generatePDF() {
    this.isPDF = true;
    this.cdr.detectChanges();
    const options = {
      margin: 10 as number,
      filename:
        this.selectedTab === 'INVOICES'
          ? 'invoicedetail.pdf'
          : 'creditdetails.pdf',
      image: { type: 'jpeg' as const },
      html2canvas: {
        scale: 1,
        letterRendering: true,
        width: 820,
        height: 760
      },
      jsPDF: { orientation: 'portrait', format: 'a4' },
    } as any;
    const elemId =
      this.selectedTab === 'INVOICES' ? 'invoice-table' : 'credits-table';
    const element = document.getElementById(elemId);
    const domClone = element.cloneNode(true);
    this.selectedTab === 'INVOICES'
      ? domClone?.childNodes[0].removeChild(
        domClone?.childNodes[0]?.childNodes[1]
      )
      : domClone.removeChild(domClone?.childNodes[1]);
    let section = null;
    section = document.createElement('SECTION');
    section.setAttribute('id', 'pdf-invoices');
    section.classList.add('pdf-invoices-view');
    section.appendChild(document.getElementById('pdf-header'));
    section.appendChild(document.getElementById('pdf-subheader'));
    section.appendChild(document.getElementById('line-sanofi'));
    section.appendChild(domClone);
    document.getElementById('pdf-dummy').appendChild(section);
    const updatedElem = document.getElementById('pdf-dummy');
    html2pdf().from(updatedElem).set(options).save();
    this.isPDF = false;
    this.cdr.detectChanges();
  }

  generateExcel() {
    const filename =
      this.selectedTab === 'INVOICES' ? 'invoicedetail' : 'creditdetails';
    let data = [];
    data = this.computeDataForExcel();
    this.acService.downloadXls(data, filename, true);
  }

  computeDataForExcel() {
    const data = [];
    if (this.selectedTab === 'INVOICES') {
      const invoiceLabelHeaders = [];
      for (const item of this.excelInvoiceHeaderIds) {
        invoiceLabelHeaders.push(document.getElementById(item).textContent);
      }
      this.paymentList.forEach((element) => {
        data.push({
          [invoiceLabelHeaders[0]]: element.blineDate,
          [invoiceLabelHeaders[1]]: element.dueDate,
          [invoiceLabelHeaders[NumberTwo]]: element.customer,
          [invoiceLabelHeaders[NumberThree]]: element.refDocNo,
          [invoiceLabelHeaders[4]]: element.amount,
          [invoiceLabelHeaders[5]]: '',
          [invoiceLabelHeaders[6]]: element.amount
        });
      });
    } else {
      const creditLabelHeaders = [];
      for (const item of this.excelCreditsHeaderIds) {
        creditLabelHeaders.push(document.getElementById(item).textContent);
      }
      this.creditList.forEach((element) => {
        data.push({
          [creditLabelHeaders[0]]: element.blineDate,
          [creditLabelHeaders[1]]: element.refDocNo,
          [creditLabelHeaders[NumberTwo]]: element.amount,
        });
      });
    }
    return data;
  }

  findAccurateDocNo(elem) {
    if (
      (elem?.docType === 'DZ' && elem?.docNo?.startsWith('7')) ||
      (elem?.docType === 'DZ' && !elem?.docNo?.startsWith('7'))
    ) {
      return elem.allocNmbr;
    } else if (elem?.docType === 'YR') {
      return elem.refhdr;
    } else {
      return elem.refDocNo;
    }
  }

  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  dateComparison(dueDate): boolean {
    return CommonUtils.dateComparison(dueDate, this.myDate);
  }
  ngOnDestroy() {
    this.creditInvoiceSub?.unsubscribe();
    this.userAccSub?.unsubscribe();
    this.csAgentAuthSubscription?.unsubscribe();
    this.billingDisplaySubscrition?.unsubscribe();
  }
  pdfOpen(invoiceNo): void {
    this.makeAPayment.downloadPdf(invoiceNo);
  }
  redirectClick(val) {
    localStorage.setItem('makePaymentTab', val)
  }
  asmStringCheck(invoiceNumber) {
    let val = (/^\d+$/).test(invoiceNumber);
    return (!val || invoiceNumber.length >= 11 || invoiceNumber.length <= 7 || (this.isAsmUser && this.isComServeAgent));
  }
}
